import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import { MAX_COMPARE_LISTING_COUNT, COMPARE_GA_CATEGORY } from 'Components/CompareGrid'

import { _CompareCta } from './styles'


const CompareCta = ({
  listing,
  comparedListings,
  toggleCompareGrid,
  addCompareListing,
  removeCompareListing,
  className,
  googleAnalyticsEvent,
  gaCategory,
  sourcePage,
  listingPage,
  listingPreview,
}) => {
  const compareNewTagRef = useRef(null)

  const isCompared = comparedListings && listing && !!comparedListings[listing.mls_number]
  const compareIsActive = isCompared ||
    Object.keys(comparedListings || {}).length < MAX_COMPARE_LISTING_COUNT

  const gaEvent = (added) => {
    const listingType = `${listing.offer} ${listing.status}`
    const gaAction = [`Compare btn toggle ${added ? 'Added' : 'Removed'}`]
    if(listingPage) gaAction.push('Listing Page Main')
    if(listingPreview) {
      gaAction.push(
        `Listing Preview ${gaCategory ? `at ${gaCategory} ` : ''}${sourcePage ? `at ${sourcePage} page` : ''}`,
      )
    }
    gaAction.push(listingType)

    googleAnalyticsEvent({
      category: COMPARE_GA_CATEGORY,
      action: gaAction,
    })
  }

  return (
    <_CompareCta
      secondary
      small
      active={isCompared}
      onClick={(e) => {
        e.stopPropagation()
        if(compareNewTagRef.current) {
          compareNewTagRef.current.setNewFeatureViewed()
        }

        if(isCompared) {
          removeCompareListing(listing)
          gaEvent(false)
        } else {
          if(compareIsActive) {
            addCompareListing(listing)
            gaEvent(true)
          }
          toggleCompareGrid({
            isOpen: true,
            showWarning: !compareIsActive,
          })
        }
      }}
      className={className}
      data-test-id="compareButton"
    >
      {isCompared ? <SvgIcon name="#icon-checkmark-slim" width={12} height={12} />
        : <SvgIcon name="#icon-compare" width={14} height={12} /> }
      Compare
    </_CompareCta>
  )
}

CompareCta.propTypes = {
  addCompareListing: PropTypes.func,
  removeCompareListing: PropTypes.func,
  comparedListings: PropTypes.shape({}),
  toggleCompareGrid: PropTypes.func,

  listing: PropTypes.shape({
    mls_number: PropTypes.string,
    offer: PropTypes.string,
    status: PropTypes.string,
  }),
  className: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  gaCategory: PropTypes.string,
  sourcePage: PropTypes.string,
  listingPreview: PropTypes.bool,
  listingPage: PropTypes.bool,
}

export default CompareCta
